import React from "react"
import { Dialog, FlatButton } from "material-ui"
import strings from "../../../localization/strings"
import ShiftSelectDays from "./ShiftSelectDays"
import { IDate, ISchedulePatternTemplate } from "../../../models"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
import * as utils from "../../../helpers/utils"
import _ from "lodash"

interface IProps {
  isScheduleTemplate: boolean
  // it's local time
  scheduleStartDate: IDate
  candidateCloneDay: number
  dayLength: number
  candidateClonePatternTemplates: ISchedulePatternTemplate[]
  handleClose(): void
  handleSave(clonePatternTemplates: ISchedulePatternTemplate[]): void
}
interface IState {
  targetCloneDays: number[]
}

export default class CloneDayDialog extends React.Component<IProps, IState> {
  private days: number[] = []
  constructor(props) {
    super(props)
    this.state = {
      targetCloneDays: []
    }
    for (let i = 0; i < props.dayLength; i++) {
      this.days.push(i)
    }
  }

  handleSave() {
    const clonePatternTemplates = []
    const candidateClonePatternTemplates = _.cloneDeep(this.props.candidateClonePatternTemplates)
    this.state.targetCloneDays.forEach(cloneDay => {
      if (this.props.isScheduleTemplate) {
        const groupedCandidateClonePatternTemplates = _.groupBy(candidateClonePatternTemplates, "Id")
        _.keys(groupedCandidateClonePatternTemplates).forEach(Id => {
          const ptId = utils.guid()
          const stIds = []
          groupedCandidateClonePatternTemplates[Id].forEach(pt => {
            pt.ShiftTemplates.forEach(j => {
              stIds.push(utils.guid())
            })
          })
          groupedCandidateClonePatternTemplates[Id].forEach(pt => {
            pt.Id = ptId
            pt.ShiftTemplates.forEach((j, index) => {
              j.Id = stIds[index]
              j.PunchInTime = null
              j.PunchOutTime = null
              j.Used = false
            })
            clonePatternTemplates.push(scheduleHelper.updatePatternTemplateTimeForDay(this.props.scheduleStartDate, cloneDay, pt))
          })
        })
      }
      else {
        candidateClonePatternTemplates.forEach(pt => {
          pt.Id = utils.guid()
          pt.ShiftTemplates.forEach(j => {
            j.Id = utils.guid()
            j.PunchInTime = null
            j.PunchOutTime = null
            j.Used = false
          })
          clonePatternTemplates.push(scheduleHelper.updatePatternTemplateTimeForDay(this.props.scheduleStartDate, cloneDay, pt))
        })
      }
    })
    this.props.handleSave(clonePatternTemplates)
  }

  render() {
    return (
      <Dialog
        id="AddShiftDialog"
        open={true}
        title={strings.formatString(strings.Clone_x_Shifts, (strings.formatString(strings.Day_X, this.props.candidateCloneDay + 1) as string).trim())}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        actions={[
          <FlatButton
            data-intercom-target={"CloneDay-Btn-CloseCloneDayDialog"}
            label={strings.CANCEL}
            secondary={true}
            onClick={this.props.handleClose}
          />,
          <FlatButton
            data-intercom-target={"CloneDay-Btn-Save"}
            label={strings.SAVE}
            primary={true}
            onClick={() => this.handleSave()}
            disabled={this.state.targetCloneDays.length === 0}
          />
        ]}
      >
        <hr />
        <div style={{ padding: 20 }}>
          <ShiftSelectDays
            isScheduleTemplate={this.props.isScheduleTemplate}
            scheduleStartDate={this.props.scheduleStartDate}
            dayLength={this.props.dayLength}
            selectedDay={this.props.candidateCloneDay}
            excludeSelectedDay
            handleSelectDays={targetCloneDays => this.setState({ targetCloneDays })}
          />
        </div>
      </Dialog>
    )
  }
}